import React from 'react';
import ReactDOM from 'react-dom';

var Sortable = React.createClass({

	render: function() {
		var items = this.getChildren().map(function(child, pos) {
			return <div className="item" key={child.props.id}>{child}</div>
		});
		return <div>{items}</div>;
	},

	componentDidMount: function() {
		var me = this;
		$(ReactDOM.findDOMNode(this)).sortable({
			tolerance: 'pointer',
			/*placeholder: 'sortable-placeholder',*/
			start: function (event, ui) {
				$(ui.item).data("startindex", ui.item.index());
				if (me.props.onStart) {
					me.props.onStart();
				}
			},
            handle: this.props.handle,
			stop: function (ev, ui) {
				var start = $(ui.item).data("startindex");
				var stop = ui.item.index();
				var k = me.getChildren().map(function (child) {
					return child.props.id;
				});
				var keys = k.toJS();
				$(this).sortable('cancel');
				$(this).trigger('click');
				if (start != stop || start == keys.length) {
					if (start == keys.length) {
						ui.item.remove();
						me.props.onAppend(stop);
					}
					else {
						var removed = keys.splice(start, 1);
						keys.splice(stop, 0, removed[0]);
						me.props.onSort(keys);
					}
				}
			}
		});
	},

	getChildren: function() {
		return this.props.children || [];
	}
});

export default Sortable;


// WEBPACK FOOTER //
// ./src/components/Sortable.js